var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.817 12.805a.598.598 0 0 1-.884 0L10 8.609l-3.933 4.196a.598.598 0 0 1-.884 0 .698.698 0 0 1 0-.943l4.375-4.667c.244-.26.64-.26.884 0l4.375 4.667a.698.698 0 0 1 0 .943Z",
    fill: "#666"
  })));
};
export default SvgArrowUp;